import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import {customersSlice} from "../app/modules/App/_redux/customers/customersSlice";
import {productsSlice} from "../app/modules/App/_redux/products/productsSlice";
import {remarksSlice} from "../app/modules/App/_redux/remarks/remarksSlice";
import {specificationsSlice} from "../app/modules/App/_redux/specifications/specificationsSlice";
import {ManageTownSlice} from "../app/modules/App/_redux/ManageTown/ManageTownSlice";
import {SensorMonitorSlice} from "../app/modules/App/_redux/SensorMonitor/SensorMonitorSlice";
import {SensorControlSlice} from "../app/modules/App/_redux/SensorControl/SensorControlSlice";
import {ManageAreasSlice} from "../app/modules/App/_redux/ManageAreas/ManageAreasSlice";
import {ManageBlocksSlice} from "../app/modules/App/_redux/ManageBlocks/ManageBlocksSlice";
import {UsersSlice} from "../app/modules/App/_redux/User/UserSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  customers: customersSlice.reducer,
  ManageTowns: ManageTownSlice.reducer,
  products: productsSlice.reducer,
  remarks: remarksSlice.reducer,
  specifications: specificationsSlice.reducer,
  SensorControls: SensorControlSlice.reducer,
  ManageAreas: ManageAreasSlice.reducer,
  ManageBlocks: ManageBlocksSlice.reducer,
  Users: UsersSlice.reducer,
  SensorMonitors: SensorMonitorSlice.reducer,
  
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
